import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { useEffect } from "react";
import CustomNavbar from "./components/CustomNavbar";
import { HomePage } from "./components/HomePage";
import { Impressum } from "./components/Impressum";
import Layout from "./Layout";
import { Datenschutz } from "./components/Datenschutz";
import { Biodanzaschule } from "./components/Biodanzaschule";
import { UeberMich } from "./components/UeberMich";
import Kontakt from "./components/Kontakt";
import { Ausbildungskalender } from "./components/Ausbildungskalender"
import { EinBeruf } from "./components/EinBeruf";
import { Ausbildung } from "./components/Ausbildung";
import { WasIstBiodanza } from "./components/WasIstBiodanza";
import { Links } from "./components/Links";
import { Mitmachen } from "./components/Mitmachen"
import { DasBiozentrischeSystem } from "./components/DasBiozentrischeSystem"
import { Events } from "./components/Events"
import { PageTransition } from "./UI/PageTransition";
import ScrollToTop from "./UI/ScrollToTop";
import SanityPage from "./components/SanityPage";




function AppRouter() {
    const location = useLocation()

    useEffect(() => {
        const isHome = location.pathname === "/"
        document.body.classList.toggle("is-home", isHome)
    }, [location.pathname])

    useEffect(() => {
        // CCM19 (cookie consent) injects a floating cookie/settings icon.
        // User request: once the user has already answered, hide that icon.
        const hasConsentSignal = () => {
            try {
                if (localStorage.getItem('ccm19-consent-set') === '1') return true
            } catch (e) {
                // ignore
            }
            try {
                const cookie = (document.cookie || '').toLowerCase()
                if (cookie.includes('ccm19') || (cookie.includes('ccm') && cookie.includes('consent'))) return true
            } catch (e) {
                // ignore
            }
            try {
                for (let i = 0; i < localStorage.length; i++) {
                    const k = (localStorage.key(i) || '').toLowerCase()
                    if (k.includes('ccm19') || (k.includes('ccm') && k.includes('consent'))) return true
                }
            } catch (e) {
                // ignore
            }
            try {
                const ccm = window.ccm19 || window.CCM19 || window.ccm || null
                if (ccm && (ccm.consent || typeof ccm.getConsent === 'function')) return true
            } catch (e) {
                // ignore
            }
            return false
        }

        let done = false
        let intervalId = null

        const markConsentSet = () => {
            try {
                localStorage.setItem('ccm19-consent-set', '1')
            } catch (e) {
                // ignore
            }
            document.body.classList.add('ccm19-consent-set')
        }

        const shouldMarkConsentFromClick = (el) => {
            if (!el) return false
            const txt = String(el.textContent || '').trim().toLowerCase()
            // Don't treat opening settings/preferences as "consent answered"
            if (
                txt.includes('einstellungen') ||
                txt.includes('settings') ||
                txt.includes('präfer') ||
                txt.includes('preferences') ||
                txt.includes('anpassen') ||
                txt.includes('customiz')
            ) {
                return false
            }
            // Common confirm actions: accept/decline/save selection
            return (
                txt.includes('akzept') ||
                txt.includes('zustimm') ||
                txt.includes('ablehn') ||
                txt.includes('nur notwendig') ||
                txt.includes('speicher') ||
                txt.includes('save') ||
                txt === 'ok' ||
                txt.includes('bestätig') ||
                txt.includes('confirm')
            )
        }

        const tick = () => {
            if (done) return
            const has = hasConsentSignal()
            document.body.classList.toggle('ccm19-consent-set', has)
            if (has) {
                done = true
                if (intervalId) window.clearInterval(intervalId)
            }
        }

        // Also listen for user interaction with the CCM19 banner/buttons to mark consent immediately,
        // even if CCM19 stores consent in an opaque way.
        const tryBindBannerClicks = () => {
            const roots = Array.from(
                document.querySelectorAll('[id*="ccm19"], [class*="ccm19"], [id*="ccm"], [class*="ccm"]')
            )
            for (const root of roots) {
                const buttons = root.querySelectorAll('button, a, input[type="button"], input[type="submit"]')
                for (const btn of buttons) {
                    if (btn.__ccm19Bound) continue
                    btn.__ccm19Bound = true
                    btn.addEventListener(
                        'click',
                        () => {
                            if (shouldMarkConsentFromClick(btn)) markConsentSet()
                        },
                        { passive: true }
                    )
                }
            }
        }

        const observer = new MutationObserver(() => {
            tryBindBannerClicks()
        })
        observer.observe(document.documentElement, { subtree: true, childList: true })
        tryBindBannerClicks()

        tick()
        intervalId = window.setInterval(tick, 1000)
        return () => {
            observer.disconnect()
            if (intervalId) window.clearInterval(intervalId)
        }
    }, [])

    return (
        < >
            <CustomNavbar />
            <ScrollToTop />
            <Layout>
                <AnimatePresence mode="wait" initial={true}>
                    <Routes location={location} key={location.pathname}>
                        <Route path="/" element={<PageTransition><HomePage /></PageTransition>} />
                        <Route path="/biodanza" element={<PageTransition><WasIstBiodanza /></PageTransition>} />
                        <Route path="/das-biozentrische-system" element={<PageTransition><DasBiozentrischeSystem /></PageTransition>} />

                        <Route path="/mitmachen" element={<PageTransition><Mitmachen /></PageTransition>} />

                        <Route path="/ein-Beruf-mit-Zukunft" element={<PageTransition><EinBeruf /></PageTransition>} />
                        <Route path="/biodanzaschuleFreibung" element={<PageTransition><Biodanzaschule /></PageTransition>} />
                        <Route path="/ausbildung" element={<PageTransition><Ausbildung /></PageTransition>} />
                        <Route path="/ausbildungskalender" element={<PageTransition><Ausbildungskalender /></PageTransition>} />
                        <Route path="/schulleitungBeateHoffman" element={<PageTransition><UeberMich /></PageTransition>} />
                        <Route path="/events" element={<PageTransition><Events /></PageTransition>} />
                        <Route path="/links" element={<PageTransition><Links /></PageTransition>} />
                        <Route path="/kontakt" element={<PageTransition><Kontakt /></PageTransition>} />

                        <Route path="/impressum" element={<PageTransition><Impressum /></PageTransition>} />
                        <Route path="/datenschutzerklaerung" element={<PageTransition><Datenschutz /></PageTransition>} />

                        {/* Generic Sanity page routes (must be last-ish) */}
                        <Route path="/ausbildung/:slug" element={<PageTransition><SanityPage /></PageTransition>} />
                        <Route path="/:slug" element={<PageTransition><SanityPage /></PageTransition>} />
                    </Routes>
                </AnimatePresence>
            </Layout>

        </>
    );
}

export default AppRouter;
